import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Layout from '../Layout/Layout';
import { routes } from './Route';
import { authRoutes } from './AuthPaths';
import menuList from '../Data/Layout/SidebarMenuList';
import { decryptData } from '../Tools/Cipher/EncryptData';
import { ReconSharedProvider } from '../Pages/BornSheet/ReconCommon/ResharedContext';

export default function LayoutRoutes() {
    const location = useLocation();
    const userResources = decryptData(localStorage.getItem("resourceList"));

    const excludedUrls = ["/organization-apps", "/company/verify", "/", "/dashboard/default", "/company/verify"];

    function filterMenuItems(data: any[], resourceList: string[]): { menu: any[], allowedUrls: string[] } {
        let allowedUrls: string[] = [];

        function traverse(obj: any): any | null {
            if (typeof obj === "object" && obj !== null) {
                let newObj = { ...obj };

                if (newObj.menu && Array.isArray(newObj.menu)) {
                    let filteredMenu: any[] = [];

                    for (let item of newObj.menu) {
                        let processedItem = traverse(item);
                        if ((item.resource && resourceList.includes(item.resource)) || (processedItem?.menu?.length > 0)) {
                            filteredMenu.push(processedItem ?? item);
                            if (item.resource && resourceList.includes(item.resource) && item.url) {
                                allowedUrls.push(item.url);
                            }
                        }
                    }

                    newObj.menu = filteredMenu.length > 0 ? filteredMenu : undefined;
                }

                if (newObj.resource && resourceList.includes(newObj.resource) && newObj.url) {
                    allowedUrls.push(newObj.url);
                }

                if (newObj.menu !== undefined || (newObj.resource && resourceList.includes(newObj.resource))) {
                    return newObj;
                }

                return null;
            }
            return null;
        }

        return {
            menu: data.map(traverse).filter(Boolean),
            allowedUrls
        };
    }

    const { allowedUrls } = filterMenuItems(menuList, userResources);

    useEffect(() => {
        const hasReloaded = sessionStorage.getItem("hasReloaded");
        // if (!hasReloaded) {
        //     sessionStorage.setItem("hasReloaded", "true");
        //     window.location.reload();
        // }
    }, []);

    // if (!allowedUrls.includes(location.pathname) && !excludedUrls.includes(location.pathname)) {
    //     return <Navigate to="/404" replace />;
    // }

    return (
        <ReconSharedProvider>
        <Routes>
            {routes.map(({ path, element }, i) => (
                <Route element={<Layout />} key={i}>
                    <Route path={path} element={element} />
                </Route>
            ))}
            {authRoutes.map(({ path, element }, i) => (
                <Route key={i} path={path} element={element} />
            ))}
        </Routes>
        </ReconSharedProvider>
    );
}
